module.exports = __webpack_public_path__ + "static/img/IMG_20240816_172411.59bb9241.jpg";